import api from "../../config/client.axios.api";

export const updateVoucherApi = async (infoUpdate: any) => {
  const response = await api.put(`/voucher`, infoUpdate);
  return response.data;
};
